import styled from "styled-components";
import { Container, Section } from "../layout/primitives";

export const AboutSection = styled(Section)`
  padding: 42px 24px;
  /* Ensure in-page links like /#about account for fixed navbar height */
  scroll-margin-top: 80px;

  @media screen and (max-width: 768px) {
    padding: 56px 0px;
  }
`;

export const LightSection = styled(Section)`
  background: #f0f0f0;
  color: #0e1a24;
  padding: 50px 24px;

  @media screen and (max-width: 768px) {
    padding: 56px 0px;
  }
`;

export const SectionInner = styled(Container)`
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Title = styled.h1`
  font-size: 40px;
  line-height: 48px;
  margin: 0;
  color: #f7f8fa;

  @media screen and (max-width: 640px) {
    font-size: 34px;
    line-height: 40px;
  }

  /* iPhone landscape: wide viewport but short height */
  @media screen and (orientation: landscape) and (max-height: 450px) {
    font-size: 38px;
    line-height: 36px;
  }
`;

export const Subtitle = styled.h2`
  font-size: 36px;
  line-height: 44px;
  margin: 0;
  color: inherit;

  @media screen and (max-width: 640px) {
    font-size: 30px;
    line-height: 32px;
  }

  /* iPhone landscape: wide viewport but short height */
  @media screen and (orientation: landscape) and (max-height: 450px) {
    font-size: 32px;
    line-height: 30px;
  }
`;

export const SectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

export const Statement = styled.strong`
  color: #f7f8fa;
  font-size: 1rem;
  line-height: 24px;
  font-weight: 600;
  max-width: 900px;
  text-align: left;

  @media screen and (min-width: 768px) {
    padding: 0 28px;
  }
`;

export const ValuesBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  margin-top: 6px;
`;

export const ValuesTitle = styled.h2`
  font-size: 52px;
  line-height: 58px;
  margin: 0;
  color: inherit;
  text-align: center;

  span {
    color: #ffcb66;
  }

  @media screen and (max-width: 640px) {
    font-size: 34px;
    line-height: 40px;
  }

  /* iPhone landscape: wide viewport but short height */
  @media screen and (orientation: landscape) and (max-height: 450px) {
    font-size: 32px;
    line-height: 30px;
  }
`;

export const ValuesIntro = styled.p`
  margin: 0;
  max-width: 840px;
  text-align: center;
  font-size: 18px;
  line-height: 28px;
  color: rgba(247, 248, 250, 0.9);
`;

export const CoreValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  width: 100%;
  max-width: 1200px;

  @media screen and (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 26px;
  }

  @media screen and (max-width: 640px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const CoreValueCard = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  column-gap: 20px;
  align-items: flex-start;
  padding: 8px 0;
`;

export const CoreValueIconWrap = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: rgba(255, 203, 102, 0.12);
  color: #ffcb66;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 1px rgba(255, 203, 102, 0.25);

  svg {
    width: 26px;
    height: 26px;
  }
`;

export const CoreValueContent = styled.div`
  border-left: 2px solid rgba(255, 255, 255, 0.12);
  padding-left: 20px;
`;

export const CoreValueTitle = styled.h3`
  margin: 0 0 6px 0;
  font-size: 24px;
  line-height: 30px;
  color: inherit;
`;

export const CoreValueText = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 25px;
  color: rgba(247, 248, 250, 0.86);
`;

export const ValuesStatement = styled.p`
  margin: 4px 0 0;
  max-width: 920px;
  font-size: 19px;
  line-height: 30px;
  color: rgba(247, 248, 250, 0.92);
  text-align: center;
`;

export const CopyBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: ${({ $maxWidth }) => $maxWidth || "900px"};
  margin: 0 auto;
  text-align: left;

  @media screen and (min-width: 768px) {
    padding: 0 28px;
  }
`;

export const Paragraph = styled.p`
  color: inherit;
  font-size: 1rem;
  line-height: 24px;
  margin: 0;
`;

export const OwnerGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  align-items: center;

  @media screen and (min-width: 768px) {
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    gap: 28px;
  }
`;

export const OwnerImageWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 8px;

  @media screen and (min-width: 768px) {
    justify-content: flex-start;
  }
`;

export const OwnerImage = styled.img`
  width: 100%;
  max-width: 360px;
  border-radius: 9999px;
`;

export const OwnerContent = styled.div`
  padding: 0 16px;

  @media screen and (min-width: 768px) {
    padding: 0 8px;
  }
`;

export const OwnerTitle = styled.h2`
  font-size: 32px;
  line-height: 40px;
  margin: 0 0 4px 0;

  @media screen and (orientation: landscape) and (max-height: 450px) {
    font-size: 26px;
    line-height: 32px;
  }
`;

export const OwnerSubtitle = styled.h3`
  font-size: 24px;
  line-height: 30px;
  margin: 0 0 12px 0;
  color: #ffcb66;

  @media screen and (orientation: landscape) and (max-height: 450px) {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 8px;
  }
`;

export const Details = styled.details`
  margin-top: 12px;
`;

export const Summary = styled.summary`
  font-size: 14px;
  line-height: 20px;
  text-decoration: underline;
  cursor: pointer;
  color: inherit;
`;

export const DetailsBody = styled.div`
  margin-top: 12px;
  font-size: 16px;
  line-height: 26px;
  color: inherit;
`;
